import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { QuickFilterLabelComponent } from './quick-filter-label.component';

@NgModule({
  imports: [CommonModule],
  declarations: [QuickFilterLabelComponent],
  exports: [QuickFilterLabelComponent],
})
export class QuickFilterLabelModule {}
